import React from 'react'

export default function Sarlaft() {
  return (
    <div>
      Sarlaft
    </div>
  )
}
